define('app-TravelPortal/login/main',['./settings', '../../app-Recaptcha/main', '../../app/ui/dialog'], function (settings, recaptcha, dialog) {
    if ($(settings.container).length === 0) {
        return null;
    }
 
    return {
        bookingNumberRegex: RegExp("^[0-9]{1,}$"),

        setupDob: function () {
            var day = $(settings.formFields.day).val().trim();
            var month = $(settings.formFields.month).val().trim();
            var year = $(settings.formFields.year).val().trim();
 
            $(settings.formFields.dateOfBirth).val(day + '\/' + month + '\/' + year);
        },

        submitForm: function (dialogText) {
            dialog.show(dialogText, null, {
                noClose: true,
                modal: true,
                draggable: false,
                resizable: false
            });
            $('form').submit();
        },

        run: function () {
            var module = this;
            $("#loginButton").on("click", function (event) {
                event.preventDefault();
                module.setupDob();
                var button = $(this);
                var dialogText = button.data("dialog-text");
                if (button.hasClass("useRecaptcha")) {
                    recaptcha.validateRecapture(event, function () {
                        module.submitForm(dialogText)
                    });
                } else {
                    localStorage.removeItem("hidden-banners");
                    module.submitForm(dialogText);
                }
            });

            var container = $(settings.dobContainer)[0];
 
            if (container) {
                container.onkeyup = function (e) {
                    var target = e.srcElement;
                    var maxLength = parseInt(target.attributes["maxlength"].value, 10);
                    var myLength = target.value.length;
 
                    if (myLength >= maxLength) {
                        var next = target;
 
                        while (next = next.nextElementSibling) {
                            if (next == null)
                                break;
                            if (next.tagName.toLowerCase() === "input") {
                                next.focus();
                                break;
                            }
                        }
                    }
                }
            }
        }
    };
});
